module.exports = __webpack_public_path__ + "static/img/朱存金.0008198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/朱存金.jpg
// module id = VBDo
// module chunks = 140